export enum AlertLevelEnum {
  Normal = 0,
  Advisory = 1,
  Watch = 2,
  Warning = 3,
}
